<template>
    <div id="app" class="wrapper">
        <Header ></Header>
        <!-- MAIN -->
        <main class="" id="content">
            <div class="inner-wrapper">

                <div class="alert alert-success" role="alert" v-if="successMessage">
                    {{ successMessage }}
                </div>

                <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    <ul>
                        <li v-for="(v, k) in commonErrors" :key="k">
                            <p v-for="error in v" :key="error" class="text-sm">
                                {{ error }}
                            </p>
                        </li>
                    </ul>
                </div>

                <ValidationObserver v-slot="{ handleSubmit }" ref="formValidation">
                    <form @submit.prevent="handleSubmit(submitHandler)" enctype="multipart/form-data">
                        <div class="page-title mb-2">
                            <h1 class="float-left">Artworks <template v-if="product_id == null">for all products</template></h1>
                        </div>

                        <div class="container-fluid whitebox" v-if="order">
                            <div class="artwork-select-header">
                                    <div class="artworks-new-head" v-if="method_id != 1 && product_id == null">
                                        <div class="form-group">
                                            <div class="form-check-inline">
                                                <label class="form-check-label">
                                                    <input type="radio" class="form-check-input"
                                                            v-model="actionMode"
                                                            value="1">Approve all artworks
                                                </label>
                                            </div>
                                            <div class="form-check-inline" v-if="product_id == null">
                                                <label class="form-check-label">
                                                    <input type="radio" class="form-check-input"
                                                            v-model="actionMode"
                                                            value="2">Request revision
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="artworks-new-head" v-if="method_id == 1">
                                        <div class="form-group">
                                            <div class="form-check-inline">
                                                <label class="form-check-label">
                                                    <input type="radio" class="form-check-input"
                                                            v-model="actionMode"
                                                            value="1">Approve all artworks
                                                </label>
                                            </div>
                                            <div class="form-check-inline">
                                                <label class="form-check-label">
                                                    <input type="radio" class="form-check-input"
                                                            v-model="actionMode"
                                                            value="2">Request revision
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            <div class="artworks-new-sec-inner ">

                                <div class="custom-row-artwork">



                                        <template v-if="method_id != 1">
                                            <template v-for="(product, index) in order.products">
                                                <template v-if="product.artworks && (product_id == null || product_id == product.id)">
                                                    <template v-for="(artwork, artworkIndex) in product.artworks">
                                                        <div class="artwork-sep">
                                                            <div class="row">
                                                                <div class="col-xl-2 col-lg-3 col-md-12 col-xs-12 artworks-left">
                                                                    <div class="artworks-left-txt-wrap" v-if="artwork.id && artwork.attach_link">
                                                                        <h3>Artwork for '{{product.product_name}}'</h3>
                                                                        <div class="custom-control custom-checkbox">
                                                                            <input type="checkbox" class="custom-control-input"
                                                                                   :value="artwork.id"
                                                                                   :id="'product_'+index+'_artwork_' + artworkIndex"
                                                                                   v-model="selectedArtworks">
                                                                            <label class="custom-control-label" :for="'product_'+index+'_artwork_' + artworkIndex"><h6> {{artwork.attach_link}}</h6></label>
                                                                        </div>

                                                                        <a href="javascript:void(0)" v-if="['png', 'jpg', 'jpeg'].some( image => artwork.attach_link.toLowerCase().includes(image))" @click="imagePreview(artwork.attach_link)" class="prev-btn">Preview</a>
                                                                        <a href="javascript:void(0)" v-on:click="download(artwork)" class="download-btn">Download</a>
                                                                        <h6>V-{{ artwork.version_number }} Uploaded {{ artwork.updated_at }}</h6>

                                                                        <h3>Status</h3>
                                                                        <template v-if="selectedArtworks.includes(artwork.id)">
                                                                            <ValidationProvider name="Status" rules="oneOf:3,4,7,8" v-slot="{ errors }">
                                                                                <div class="form-check" v-if="actionMode==1 || actionMode ==null">
                                                                                    <input type="radio" class="form-check-input"
                                                                                           v-model="order.products[index].artworks[artworkIndex].artwork_status_id"
                                                                                           value="8">
                                                                                    <label class="form-check-label">Approve</label>
                                                                                </div>
                                                                                <div class="form-check" v-if="actionMode==2 || actionMode ==null">
                                                                                    <input type="radio" class="form-check-input" readonly
                                                                                           v-model="order.products[index].artworks[artworkIndex].artwork_status_id"
                                                                                           value="7">
                                                                                    <label class="form-check-label">Request revision</label>
                                                                                </div>
                                                                                <div class="error" v-if="errors.length">
                                                                                    {{errors[0]}}
                                                                                </div>
                                                                            </ValidationProvider>
                                                                            <!--<div class="form-check">
                                                                                <input type="checkbox" class="form-check-input">
                                                                                <label class="form-check-label" for="exampleCheck1"> Request revision</label>
                                                                            </div>-->
                                                                        </template>
                                                                        <template v-else>
                                                                            <div class="form-check">
                                                                                <input type="radio" class="form-check-input"
                                                                                       v-model="order.products[index].artworks[artworkIndex].artwork_status_id"
                                                                                       value="8">
                                                                                <label class="form-check-label">Approve</label>
                                                                            </div>
                                                                            <div class="form-check">
                                                                                <input type="radio" class="form-check-input" readonly
                                                                                       v-model="order.products[index].artworks[artworkIndex].artwork_status_id"
                                                                                       value="7">
                                                                                <label class="form-check-label">Request revision</label>
                                                                            </div>
                                                                        </template>

                                                                        <template v-if="artwork.artwork_status_id == 7">
                                                                            <h3>Reason</h3>
                                                                            <textarea class="form-control" rows="3" v-model="order.products[index].artworks[artworkIndex].reason"></textarea>
                                                                        </template>
                                                                    </div>
                                                                </div>

                                                                <div class="col-xl-8 col-lg-6 col-md-12 col-xs-12 artworks-mid">
                                                                    <div class="artworks-wrap">
                                                                        <ArtworkImage :order="order" :artwork="artwork" :is_edit="artwork.artwork_status_id == 7" :bus="bus" @commentAdded="commentAdded"></ArtworkImage>
                                                                    </div>
                                                                </div>

                                                                <div class="col-xl-2 col-lg-3 col-md-12 col-xs-12 artworks-right">
                                                                    <ArtworkComment :order="order" :artwork="artwork" :is_edit="true" @commentDeleted="commentDeleted" :bus="bus"></ArtworkComment>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>


                                        <template v-if="method_id == 1">
                                            <div class="artwork-sep">
                                                <div class="row">
                                                    <div class="col-xl-2 col-lg-3 col-md-12 col-xs-12 artworks-left">
                                                        <div class="artworks-left-txt-wrap" v-if="order.latest_artwork.id && order.latest_artwork.attach_link">
                                                            <h3>Artwork</h3>
                                                            <h6> {{order.latest_artwork.attach_link}}</h6>
                                                            <a href="javascript:void(0)" v-if="['png', 'jpg', 'jpeg'].some( image => order.latest_artwork.attach_link.toLowerCase().includes(image))" @click="imagePreview(order.latest_artwork.attach_link)" class="prev-btn">Preview</a>
                                                            <a href="javascript:void(0)" v-on:click="download(order.latest_artwork)" class="download-btn">Download</a>
                                                            <h6>V-{{ order.latest_artwork.version_number }} Uploaded {{ order.latest_artwork.updated_at }}</h6>

                                                            <h3>Status</h3>
                                                            <ValidationProvider name="Status" rules="oneOf:3,4,7,8" v-slot="{ errors }">
                                                                <div class="form-check">
                                                                    <input type="radio" class="form-check-input"
                                                                        v-model="order.latest_artwork.artwork_status_id"
                                                                        value="8">
                                                                    <label class="form-check-label">
                                                                        Approve
                                                                    </label>
                                                                </div>
                                                                <div class="form-check">
                                                                    <input type="radio" class="form-check-input"
                                                                        v-model="order.latest_artwork.artwork_status_id"
                                                                        value="7">
                                                                    <label class="form-check-label">
                                                                        Request revision
                                                                    </label>
                                                                </div>
                                                                <div class="error" v-if="errors.length">
                                                                    {{errors[0]}}
                                                                </div>
                                                            </ValidationProvider>
                                                            <!--<div class="form-check">
                                                                <input type="checkbox" class="form-check-input">
                                                                <label class="form-check-label" for="exampleCheck1"> Request revision</label>
                                                            </div>-->

                                                            <template v-if="order.latest_artwork.artwork_status_id == 7">
                                                                <h3>Reason</h3>
                                                                <textarea class="form-control" rows="3" v-model="order.latest_artwork.reason"></textarea>
                                                            </template>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-8 col-lg-6 col-md-12 col-xs-12 artworks-mid">
                                                        <div class="artworks-wrap">
                                                            <ArtworkImage :order="order" :artwork="order.latest_artwork" :is_edit="order.latest_artwork.artwork_status_id == 7" :bus="bus" @commentAdded="commentAdded"></ArtworkImage>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-2 col-lg-3 col-md-12 col-xs-12 artworks-right"><ArtworkComment :order="order" :artwork="order.latest_artwork" :is_edit="true" @commentDeleted="commentDeleted" :bus="bus" ref="fixedArtworkCommentRef"></ArtworkComment></div>
                                                </div>
                                            </div>
                                        </template>


                                </div>
                                <!--<div class="alert alert-success" role="alert" v-if="successMessage">
                                    {{ successMessage }}
                                </div>-->
                                <button type="submit" v-if="!isSaved" class="btn btn-primary" :disabled="loading || isSaved">Submit</button>
                                <template v-if="isSaved && !loading">
                                    <div class="alert alert-success" role="alert">
                                        <template v-if="method_id != 1">
                                            <template v-if="artwork_id !=null && order.products && order.products.length && order.products[0].artworks && order.products[0].artworks.length">
                                                <template v-if="order.products[0].artworks[0].artwork_status_id == 8">
                                                    Approved
                                                </template>
                                                <template v-if="order.products[0].artworks[0].artwork_status_id == 7">
                                                    Revision requested
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-if="actionMode == 1">
                                                    Approved
                                                </template>
                                                <template v-if="actionMode == 2">
                                                    Revision requested
                                                </template>

                                                <template v-if="actionMode == null && order.products && order.products.length">
                                                    <ul>
                                                        <li v-for="(product) in order.products.filter((x) => x.artworks && x.artworks.filter((y) => [7,8].includes(y.artwork_status_id)).length)">
                                                            <template v-for="(artwork) in product.artworks">
                                                                <template v-if="artwork.artwork_status_id == 8">
                                                                    Approved artwork of "{{product.product_name}}"
                                                                </template>
                                                                <template v-if="artwork.artwork_status_id == 7">
                                                                    Revision requested for "{{product.product_name}}"
                                                                </template>
                                                            </template>
                                                        </li>
                                                    </ul>
                                                </template>
                                            </template>

                                        </template>
                                        <template v-if="method_id == 1">
                                            <template v-if="actionMode == 1 || order.latest_artwork.artwork_status_id == 8">
                                                Approved
                                            </template>
                                            <template v-if="actionMode == 2 || order.latest_artwork.artwork_status_id == 7">
                                                Revision requested
                                            </template>
                                        </template>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </form>
                </ValidationObserver>

                <LightBox :media="previewMedia" :showLightBox="false" :showThumbs="false" ref="lightbox"></LightBox>

                <div class="copyright">
                    <p>© Copyright 2021. All right reserved. Superb Packaging Inc.</p>
                </div>
            </div>
        </main>
        <Footer></Footer>
        <ArtworkCommentModal :order="order" :artwork="targetArtwork" :is_edit="true"></ArtworkCommentModal>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import axios from "axios";
import LightBox from 'vue-it-bigger';
import {ValidationProvider, ValidationObserver, extend, configure} from 'vee-validate';
import ArtworkCommentModal from "../../components/ArtworkCommentModal";
import ArtworkComment from "../../components/ArtworkComment";
import ArtworkImage from "../../components/ArtworkImage";
import Vue from "vue";

configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
        // ...
    }
});

extend('positive', value => {
    if (value >= 0) {
        return true;
    }

    return 'This field must be a positive number';
});


export default {
    name: "Artworks",
    components: {
        ValidationObserver, ValidationProvider,
        LightBox,
        ArtworkCommentModal,
        ArtworkComment,
        ArtworkImage
    },
    mounted() {
        this.setSuccessMessage(null);
        if(this.$route.params.artwork_id) {
            this.artwork_id = this.$route.params.artwork_id;
        }
        if(this.$route.params.product_id) {
            this.product_id = this.$route.params.product_id;
        }

        if(this.$route.params.method_id) {
            this.method_id = this.$route.params.method_id;
        }

        let self = this;
        $('#artworkCommentModal').on('hidden.bs.modal', function () {
            self.targetArtwork = null;
        })

        this.getOrder();
    },
    data() {
        return {
            bus: new Vue(),
            order: null,
            artwork_id: null,
            product_id: null,
            method_id: null,
            customer: null,
            product: null,
            artwork: null,
            artwork_statuses: [],
            sub_total_cost: 0,
            previewMedia: [],
            isSaved: false,
            targetArtwork: null,
            actionMode: null,
            checkAll: false,
            selectedArtworks: [],
            originalOrder: null
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
            'setNewPurchaseOrder',
            'setNewOrder'
        ]),
        checkAllEvent(event) {
            this.selectedArtworks = [];
            if(event.target.checked) {
                this.order.products.forEach((product) => {
                    product.artworks.forEach((artwork) => {
                        this.selectedArtworks.push(artwork.id);
                    });
                });

            }
        },
        addCommentModal(artwork) {
            this.targetArtwork = artwork;
            setTimeout(() => {
                $('#artworkCommentModal').modal('show');
            }, 100);

        },
        imagePreview(src) {
            let url = window.route('medias.view', {
                path: 'so_attachments',
                id: this.order.id,
                name: src
            });
            this.previewMedia = [{
                thumb: url,
                src: url,
                caption: '', // Optional
                //srcset: '...' // Optional for displaying responsive images
            }];
            this.$refs.lightbox.showImage(0)
        },
        submitHandler() {
            this.$refs.formValidation.validate().then(success => {
                if (!success) {
                    return;
                }
                this.saveOrder();
            });
        },
        commentDeleted(event){
            this.bus.$emit('commentDeletedAffect', event);
        },
        commentAdded(event){
            this.bus.$emit('newCommentAdded', event);
        },
        getComments(artwork_id) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('artworks.get.comments', {id: this.order.id, artwork_id: artwork.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.comments = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        saveOrder(e) {
            if(this.isSaved) {
                return ;
            }
            this.isSaved = true;
            this.order.product_id = this.product_id;
            this.order.artwork_id = this.artwork_id;
            this.order.actionMode = this.actionMode;
            this.order.method_id = this.method_id;
            this.order.selectedArtworks = this.selectedArtworks;

            let self = this;
            this.submitted = true;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('artworks.orders.update', {id: this.order.id}), this.order, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                        this.isSaved = false;
                    } else {
                        self.setSuccessMessage('Submitted successfully!');
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                            //self.isSaved = false;
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);
                    this.isSaved = false;
                })
                .finally(() => {
                    self.setLoading(false);

                });

        },
        download(artwork) {
            let url = window.route('medias.download', {
                path: 'so_attachments',
                id: this.order.id,
                name: artwork.attach_link,
                pdf_to_image: 0
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url, {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", artwork.attach_link);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        downloadOriginalArtwork(original_customer_file) {
            let url = window.route('medias.download', {
                path: 'so_attachments',
                id: this.order.id,
                name: original_customer_file,
                pdf_to_image: 0
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url, {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", original_customer_file);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getOrder() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('artworks.orders.show', {id: this.$route.params.id},), {
                params: {
                    product_id: this.product_id,
                    artwork_id: this.artwork_id
                },
                headers: {
                    'Content-Type': 'application/json',
                },
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        if(this.product_id == null && this.artwork_id == null) {
                            data.data.products.forEach((product, index) => {
                                data.data.products[index].artworks = product.artworks.filter((x) => x.id == product.latest_artwork.id);
                            });
                        }
                        if(data.data.artworks && data.data.artworks.length > 0) {
                            if(!data.data.latest_artwork && data.data.latestArtwork) {
                                data.data.latest_artwork = _.cloneDeep(data.data.latestArtwork)
                            } else if(!data.data.latest_artwork && !data.data.latestArtwork) {
                                data.data.latest_artwork = _.cloneDeep(data.data.artworks[data.data.artworks.length - 1]);
                            }
                            if(data.data.latest_artwork){
                                data.data.artworks = data.data.artworks.filter((x) => x.id == data.data.latest_artwork.id);
                            }
                        }
                        this.originalOrder = _.cloneDeep(data.data);
                        this.order = _.cloneDeep(data.data);
                        this.order.product_id = this.product_id;
                        this.order.artwork_id = this.artwork_id;
                        this.customer = data.customer;
                        this.artwork_statuses = data.artwork_statuses;

                        if (this.order.products) {
                            this.sub_total_cost = 0;
                            this.selectedProducts = [];
                            this.order.products.forEach((x, index) => {
                                if(this.$route.params.artwork_id && x.artworks) {
                                    x.artworks.forEach((art, artworkIndex) => {
                                        if(![3,4,7].includes(art.artwork_status_id)){
                                            this.order.products[index].artworks[artworkIndex].artwork_status_id = 3;
                                        } else {
                                            this.order.products[index].artworks[artworkIndex].artwork_status_id = art.artwork_status_id;
                                        }
                                    });
                                    let artwork = product.artworks.find((y) => y.id == this.$route.params.artwork_id);
                                    if(artwork) {
                                        this.artwork = _.cloneDeep(artwork);
                                        this.product = _.cloneDeep(x);
                                    }
                                } else {

                                }
                                this.selectedProducts.push(x.product_id)
                                if (!isNaN(parseInt(x.cost))) {
                                    this.sub_total_cost += parseInt(x.cost);
                                }
                            });
                        }

                        this.sub_total_cost = this.order.amount;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    },
    watch: {
        selectedArtworks: {
            handler: function (valueAfter, valueBefore) {
                // console.log(valueAfter, valueBefore)
                this.order.products.forEach((product) => {
                    product.artworks.forEach((artwork) => {
                        if(valueAfter.includes(artwork.id)) {
                            if(this.actionMode == 1) {
                                artwork.artwork_status_id =  8;
                            } else if(this.actionMode == 2) {
                                artwork.artwork_status_id =  7;
                            }

                        } else {
                            this.originalOrder.products.forEach((productOld) => {
                                let artworkOld = productOld.artworks.find((x) => x.id = artwork.id);
                                if(artworkOld) {
                                    artwork.artwork_status_id = artworkOld.artwork_status_id;
                                }
                            });
                        }
                    });
                });
            }
        },
        actionMode: {
            handler: function (valueAfter, valueBefore) {
                //console.log(valueAfter, valueBefore)
                if(this.method_id == 1) {
                    if(valueAfter == 1) {
                        this.order.latest_artwork.artwork_status_id =  8;
                    } else if(valueAfter == 2) {
                        this.order.latest_artwork.artwork_status_id =  7;
                    }
                }
                this.order.products.forEach((product) => {
                    product.artworks.forEach((artwork) => {
                        this.selectedArtworks.push(artwork.id);
                        if(valueAfter == 1) {
                            artwork.artwork_status_id =  8;
                        } else if(valueAfter == 2) {
                            artwork.artwork_status_id =  7;
                        }
                        /*if(this.selectedArtworks.includes(artwork.id)) {
                            if(valueAfter == 1) {
                                artwork.artwork_status_id =  8;
                            } else if(valueAfter == 2) {
                                artwork.artwork_status_id =  7;
                            }

                        } else {
                            this.originalOrder.products.forEach((productOld) => {
                                let artworkOld = productOld.artworks.find((x) => x.id = artwork.id);
                                if(artworkOld) {
                                    artwork.artwork_status_id = artworkOld.artwork_status_id;
                                }
                            });
                        }*/
                    });
                });
            }
        }
    }
}
</script>

<style scoped>
#content .inner-wrapper{
    width:100%;
}
.card{
    padding: 10px;
}
</style>
